import { render, staticRenderFns } from "./SFloatingNotification.vue?vue&type=template&id=07fb0ddb&scoped=true"
import script from "./SFloatingNotification.vue?vue&type=script&lang=js"
export * from "./SFloatingNotification.vue?vue&type=script&lang=js"
import style0 from "./SFloatingNotification.vue?vue&type=style&index=0&id=07fb0ddb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fb0ddb",
  null
  
)

export default component.exports